import React from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MatrixDriverVendor from 'pages/vendor/driverVendor/MatrixDriverVendor';
import CommonTable from 'components/commonTable/CommonTable';
import CommonFilter from 'components/commonFilter/CommonFilter';
import { matrixCustomerData } from './MatrixCustomerData';
import Loader from 'components/loader/Loader';

function CustomerTab(props) {

  const handleChange = (event, newValue) => {
    props?.handleChange(newValue)
  };

  const onClickCustomer = (data) => {
    console.log(data)
  }

  return (
    <Grid container>

      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                  }}
                >
                  <Tab
                    label="Matrix"
                    value="1"
                    className="tabStyle"
                  />
                  
                </TabList>

              </Grid>
              {props?.value === '2'?
              <Grid item className="filterAlign">
                <CommonFilter filterdata={props?.filterdata} onFilterChange={props?.onFilterChange} onRestFilter={props?.onRestFilter}/>
              </Grid> : null}
                  
            </Grid>
            <TabPanel value="1" className='customerTable width100'>
            {props?.loadermatrixData ? <Loader/> :
              <MatrixDriverVendor matrix={matrixCustomerData(props?.matrixData)}/>}
            </TabPanel>
            <TabPanel value="2" className='vendotTable'> 
              <CommonTable 
                data={props?.ticketData} 
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                page={props?.page}
                rowsPerPage={props?.rowsPerPage}
                tabName={props?.tabName}
                onClickTableVendor={onClickCustomer}
                isClickable = {false}
              />
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default CustomerTab;
